import { useEffect } from 'react';
import { addEventListener } from '../utils/dom';
function useKeyPress(keys = [], onKeyPress) {
    useEffect(() => {
        if (!onKeyPress) {
            return;
        }
        const handleKeyDown = event => {
            const { keyCode } = event;
            if (keys.includes(keyCode)) {
                onKeyPress(event);
            }
        };
        const off = addEventListener('keydown', handleKeyDown);
        return () => off === null || off === void 0 ? void 0 : off();
    }, [keys, onKeyPress]);
}
export default useKeyPress;
//# sourceMappingURL=use-keypress.js.map